import { Box, Button, Typography } from "@mui/joy";
import React, { useRef, useState } from "react";
import { Dialog } from 'primereact/dialog';
import GenericTableView from "../../components/GenericTableView";
import { FilterMatchMode } from "primereact/api";
import { GenericTableColumTypes, GenericTableFilterTypes } from "../../enum/TableView";
import { MenuItem } from "primereact/menuitem";
import { GenericTableColumns } from "../../models/GenericTableViewModel";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from 'primereact/toast';
import { RouteComponentProps } from "../../models/RouteComponent";
import { legislationRemove } from "../../service/legislationService";
import AttendanceAdd from "./attendance-add";

export default function AttendanceView(props: RouteComponentProps) {

  const [selectedRecord, setRecord] = useState({} as any);
  const [visible, setVisible] = useState(false);
  const [reload, setReload] = useState(false);
  const toast = useRef(null as any);
  const dialog = useRef(null as any);

  const client_id = props?.session?.client_id;
  const site_id = props?.session?.site_id;

  const baseFilter = {
    'description': { value: '', matchMode: FilterMatchMode.CONTAINS },
    'start_at': { value: undefined, matchMode: FilterMatchMode.DATE_IS }
  }

  const addButton = (row: any) => {
    console.log("addButton row == ", row)
    setRecord(null);
    setVisible(true);
  }

  const itemSelected = (row: any) => {
    console.log("itemSelected row == ", row)
    setRecord(row.value);
    editConfirm(row);
    // setVisible(true);
  }

  const contextItemSelected = (row: any) => {
    console.log("contextItemSelected row == ", row)
    setRecord(row.value);
  }

  const acceptFunc = async () => {
    props.setGlobalLoader(true);
    const industry = await legislationRemove(selectedRecord.id);
    props.setGlobalLoader(false);
    setReload(!reload);
    toast.current.show({ severity: 'success', summary: 'Legislation Deleted Successfully', life: 3000 });
  }

  const deleteConfirm = (row: any) => {
    confirmDialog({
      message: 'Are you sure you want to proceed?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => acceptFunc()
    });
  }

  const editConfirm = (row: any) => {
    setVisible(true);
  }

  const contextItems = () => {
    let objArray = [
      { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: editConfirm },
    ];
    objArray.push({ label: 'Delete', icon: 'pi pi-fw pi-trash', command: deleteConfirm });
    return objArray;
  }

  const columns: GenericTableColumns[] = [
    {
      field: 'type',
      header: 'Type',
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: false,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'full_name',
      header: 'Full Name',
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'start_at',
      header: 'Check In Date',
      type: GenericTableColumTypes.DateTime,
      visible: true,
      sort: true,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.DateTime,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'end_at',
      header: 'Check Out Date',
      type: GenericTableColumTypes.DateTime,
      visible: true,
      sort: true,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.DateTime,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'on_site',
      header: 'On Site',
      type: GenericTableColumTypes.Boolean,
      visible: true,
      sort: true,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Boolean,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    // Add Entry and Exit time on site
    {
      field: 'time_on_site',
      header: 'Time On Site',
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: false,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'mobile',
      header: 'Mobile',
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: false,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'email',
      header: 'Email',
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: false,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [{
          label: '',
          value: ''
        }]
      }
    }
  ];


  return (
    <React.Fragment>
      <Box
        sx={{
          display: 'flex',
          mb: 1,
          gap: 1,
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'start', sm: 'center' },
          flexWrap: 'wrap',
          justifyContent: 'space-between',
        }}
      >
        <Typography level="h2" component="h1">
          Attendance
        </Typography>


        {/* <Button
            color="primary"
            startDecorator={<Add />}
            size="sm"
            onClick={() => setVisible(true)}
          >Add</Button> */}
      </Box>

      <GenericTableView reload={reload} baseFilters={baseFilter} url="attendance" columns={columns} contextItems={contextItems} addButton={addButton} exportName="Attendance" itemSelect={itemSelected} contextItemSelected={contextItemSelected} />

      <Dialog ref={dialog} header={selectedRecord?.id ? 'Update Attendance' : 'Add Attendance'} visible={visible} style={{ width: '50vw' }} onHide={() => setVisible(false)}>
        <AttendanceAdd setGlobalLoading={props.setGlobalLoader} setReload={setReload} reload={reload} id={selectedRecord?.id} record={selectedRecord} setVisible={setVisible} toast={toast} client_id={client_id} site_id={site_id} />
      </Dialog>

      <ConfirmDialog />

      <Toast ref={toast} />


    </React.Fragment>
  );
}